/** Stored user role for bidders (displayed as "Bidder" in the UI). */
export const BIDDER_ROLE = "member";

export const ALL_ROLES = [
  "member",
  "lead",
  "admin",
  "superadmin",
  "caller",
  "assistant",
];

/** Roles that cannot sign in or access protected routes. Bidder records can still be created for daily logs. */
export const DISABLED_ROLES = [BIDDER_ROLE];

export const DISABLED_ROLE_MESSAGE =
  "The Bidder role is deactivated. Contact an administrator if you need access.";

export function isRoleDisabled(role) {
  return DISABLED_ROLES.includes(role);
}

export function isAssignableRole(role) {
  return ALL_ROLES.includes(role);
}
